import { render, staticRenderFns } from "./TheRefundRequestForm.vue?vue&type=template&id=6c996236&scoped=true&"
import script from "./TheRefundRequestForm.vue?vue&type=script&lang=js&"
export * from "./TheRefundRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./TheRefundRequestForm.vue?vue&type=style&index=0&id=6c996236&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c996236",
  null
  
)

export default component.exports